import {Box} from "@mui/material";
import {Anchor, Group, Text} from "@mantine/core"
import {IconShoppingCart} from "@tabler/icons-react";
import {isEmpty} from "lodash";

export const ResultsHighlight = ({
                                     title,
                                     list = [],
                                     style = {},
                                     isPositive
                                 }) => {
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                ...style,
            }}
        >
            <Text
                fw={'bold'}
                color={isPositive ? "green" : "red"}
            >
                {title}
            </Text>

            {list?.map((item, idx) => {
                return (
                    <div key={idx} className={'flex flex-col py-4 border-t-2'}>
                        <Text
                            fw={'bold'}
                            size={'lg'}
                        >
                            {item.title}
                        </Text>

                        <Text
                            mt={'md'}
                        >
                            {item.description}
                        </Text>

                        {!isEmpty(item.recommended_products) &&
                            <Group
                                style={{
                                    alignItems: 'center',
                                    marginTop: 16,
                                    ...style,
                                }}
                            >
                                <IconShoppingCart/>

                                <Anchor href={item.recommended_products?.[0]?.product_link} target="_blank">
                                    Shop {item.recommended_products?.[0]?.product_title}
                                </Anchor>
                            </Group>
                        }
                    </div>
                )
            })}
        </Box>
    )
}
